import React, { type ReactElement, type ReactNode } from 'react'
import Button, { type ButtonProps } from '@mui/material/Button'

export enum BUTTON_VARIANTS {
  primary = 'primary',
  secondary = 'secondary',
  outlined = 'outlined',
  iconSecondary = 'iconSecondary',
  iconTertiary = 'iconTertiary',
  contained = 'contained',
  text = 'text',
}
export enum BUTTON_SIZE {
  large = 'large',
  small = 'small',
}

export interface ThemeButtonProps extends ButtonProps {
  children?: ReactNode
  variant?: BUTTON_VARIANTS
  size?: BUTTON_SIZE
}

const ThemeButton: React.FC<ThemeButtonProps> = ({
  children,
  variant = BUTTON_VARIANTS.primary,
  size = BUTTON_SIZE.large,
  ...rest
}): ReactElement => {
  return (
    <Button variant={variant} size={size} {...rest}>
      {children}
    </Button>
  )
}

export default ThemeButton
